export interface INavigationRoute {
  name: string
  displayName: string
  permission_name: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      permission_name: 'Dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'staffs',
      displayName: 'menu.staffs',
      permission_name: 'User Management',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'roles',
      displayName: 'menu.roles',
      permission_name: 'Role Management',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'projects-list',
      displayName: 'menu.projects',
      permission_name: 'Project Management',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'clients-list',
      displayName: 'menu.clients',
      permission_name: 'Client Management',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'invoices-list',
      displayName: 'menu.invoices',
      permission_name: 'Invoice Management',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'payments-list',
      displayName: 'menu.payments',
      permission_name: 'Payment Management',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'payment-sources',
      displayName: 'menu.payment_sources',
      permission_name: 'Payment Source Management',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'tasks-list',
      displayName: 'menu.tasks',
      permission_name: 'Task Management',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'profile-settings',
      displayName: 'menu.settings',
      permission_name: 'Dashboard',
      meta: {
        icon: 'settings',
      },
    },
    {
      name: 'Payroll',
      displayName: 'menu.payroll',
      permission_name: 'Payroll Management',
      meta: {
        icon: 'credit_card',
      },
      children: [
        {
          name: 'employees',
          displayName: 'menu.employees',
          permission_name: 'Employee Management',
        },
        {
          name: 'payrolls',
          displayName: 'menu.payroll-list',
          permission_name: 'Employee Management',
        },
        // {
        //   name: 'payroll-items',
        //   displayName: 'menu.payroll_items',
        //   permission_name: 'Payroll Item Management',
        // },
        // {
        //   name: 'pricing-plans',
        //   displayName: 'menu.pricing-plans',
        // },
        // {
        //   name: 'billing',
        //   displayName: 'menu.billing',
        // },
      ],
    },
    // {
    //   name: 'users',
    //   displayName: 'menu.users',
    //   meta: {
    //     icon: 'group',
    //   },
    // },
    // {
    //   name: 'payments',
    //   displayName: 'menu.payments',
    //   meta: {
    //     icon: 'credit_card',
    //   },
    //   children: [
    //     {
    //       name: 'payment-methods',
    //       displayName: 'menu.payment-methods',
    //     },
    //     {
    //       name: 'pricing-plans',
    //       displayName: 'menu.pricing-plans',
    //     },
    //     {
    //       name: 'billing',
    //       displayName: 'menu.billing',
    //     },
    //   ],
    // },
    // {
    //   name: 'auth',
    //   displayName: 'menu.auth',
    //   meta: {
    //     icon: 'login',
    //   },
    //   children: [
    //     {
    //       name: 'login',
    //       displayName: 'menu.login',
    //     },
    //     {
    //       name: 'signup',
    //       displayName: 'menu.signup',
    //     },
    //     {
    //       name: 'recover-password',
    //       displayName: 'menu.recover-password',
    //     },
    //   ],
    // },

    // {
    //   name: 'faq',
    //   displayName: 'menu.faq',
    //   meta: {
    //     icon: 'quiz',
    //   },
    // },
    // {
    //   name: '404',
    //   displayName: 'menu.404',
    //   meta: {
    //     icon: 'vuestic-iconset-files',
    //   },
    // },
    // {
    //   name: 'preferences',
    //   displayName: 'menu.preferences',
    //   meta: {
    //     icon: 'manage_accounts',
    //   },
    // },
    // {
    //   name: 'settings',
    //   displayName: 'menu.settings',
    //   meta: {
    //     icon: 'settings',
    //   },
    // },
  ] as INavigationRoute[],
}
